<div class="card modern-card d-flex flex-column">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Disposition</h1>
      </div>

      <div class="header-actions">
        <button type="button" class="close-btn" (click)="openHome()" title="Close">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body p-0 d-flex flex-column flex-grow-1">
    <mat-horizontal-stepper [linear]="true" [selectedIndex]="1" #stepper (selectionChange)="enableNextBtn($event)">
      <!-- Custom icon for 'edit' state -->
      <ng-template matStepperIcon="edit">
        <mat-icon>check_circle</mat-icon>
      </ng-template>
      <!-- Custom icon for 'done' state -->
      <ng-template matStepperIcon="done">
        <mat-icon>check_circle</mat-icon>
      </ng-template>
      <mat-step label="Firearm Selection" [completed]="true" [editable]="false">
        <!-- Step 1 content goes here -->
      </mat-step>
      <mat-step label="Disposition To">
        <!-- Step 2 content goes here -->
      </mat-step>
      <mat-step label="Review Disposition">
        <!-- Step 3 content goes here -->
      </mat-step>
      <mat-step label="Submit Disposition">
        <!-- Step 4 content goes here -->
      </mat-step>
    </mat-horizontal-stepper>
    <!-- <app-step-progress-bar></app-step-progress-bar> -->
    <hr class="divider" />

    <form [formGroup]="disposition_form" class="d-flex flex-column flex-grow-1">
      <div class="background-img flex-grow-1">
        <div class="row justify-content-end">
          @if (stepper.selectedIndex === 1) {
          <div>
            <span class="required" style="font-weight: bold; margin-left: 20px">*</span>
            <span style="color: white">
              Denotes a required field: {{ selected_dispo_type }}</span>
          </div>
          }
          <!-- left side step 2 -->
          @if (stepper.selectedIndex === 1) {
          <div class="col-6 left_side" style="min-height: 475px">
            <!-- Form 4473 # -->
            @if (selected_dispo_type === "Individual") {
            <div class="form_input disposition-id-row">
              <button type="button" class="btn btn-primary top-label" style="margin-right: 10px; margin-top: 15px"
                (click)="generate4473IdClick()" tooltip="Generate 4473 ID">
                <i class="fa-solid fa-gears"></i>
              </button>
              <label class="control-label label" for="form_4473_no" style="display: inline-block">
                <span class="required">*</span> Form 4473 #:
              </label>
              <input appOnlyNumbers type="text" class="form-control text-uppercase input" formControlName="form_4473_no"
                style="
                      display: inline-block;
                      width: 190px;
                      margin-right: 0px;
                    " (input)="setForm4473IdManual()" />
              <!-- (change)="verify4473()" -->
              <button type="button" class="btn btn-primary" style="width: 200px; margin-right: 150px; margin-top: 15px"
                (click)="changeDispoType()">
                Dispose To FFL
              </button>
            </div>
            }
            <!-- FFL -->
            @if (selected_dispo_type === "FFL") {
            <div class="form_input disposition-ffl-row">
              <button type="button" class="btn btn-primary btn-sm top-label"
                style="margin-right: 10px; margin-top: 10px" (click)="fflSearchClick()">
                FFL Search
              </button>
              <label class="control-label label" for="ffl" style="display: inline-block">
                <span class="required">*</span> FFL:
              </label>
              <div class="ffl-input-with-status">
                <input type="text" class="form-control text-uppercase input" formControlName="ffl" style="
                        display: inline-block;
                        width: 210px;
                        margin-right: 0px;
                      " [placeholder]="'_-__-___-__-__-_____'" [dropSpecialCharacters]="false"
                  mask="0-00-000-00-0A-00000" (input)="fetchFfl()" />
                @if (ffl_verified && networkSyncService.isOnline) {
                <i class="fa-solid fa-circle-check ffl_verified_icon" data-bs-toggle="tooltip" data-bs-placement="top"
                  title="Verified by ATF Ezcheck"></i>
                }
                @if (!networkSyncService.isOnline) {
                <i tooltip="FFL can not be verified while offline"
                  class="fa-solid fa-triangle-exclamation offline_icon"></i>
                }
              </div>
              <button type="button" class="btn btn-primary" style="width: 180px; margin-right: 150px; margin-top: 15px"
                (click)="changeDispoType()">
                Dispose To Individual
              </button>
            </div>
            }
            <!-- Received From  -->
            @if (selected_dispo_type === "FFL") {
            <div class="form_input">
              <label class="control-label label" for="disposed_to" style="display: inline-block">
                <span class="required">*</span> Disposed To:
              </label>
              <input type="text" class="form-control text-uppercase input" formControlName="disposed_to"
                style="display: inline-block" />
            </div>
            }
            <!-- Business Name -->
            @if (selected_dispo_type === "FFL") {
            <div class="form_input">
              <label class="control-label label" for="business_name" style="display: inline-block">
                <!-- <span class="required">*</span>  -->
                Business Name:
              </label>
              <input type="text" class="form-control text-uppercase input" formControlName="business_name"
                style="display: inline-block" />
            </div>
            }
            <!-- First Name -->
            @if (selected_dispo_type !== "FFL") {
            <div class="form_input disposition-name-row">
              <label class="control-label label" for="first_name" style="display: inline-block">
                <span class="required">*</span> First Name:
              </label>
              <input type="text" class="form-control text-uppercase input" formControlName="first_name" style="
                      display: inline-block;
                      margin-right: 0px;
                      width: 345px;
                    " />
              <button type="button" class="btn btn-primary top-label" style="margin-right: 150px; margin-top: 15px"
                (click)="selectDriversLicenseClick()" tooltip="Select Drivers License">
                <i class="fa-solid fa-address-card"></i>
              </button>
            </div>
            }
            <!-- Middle Name -->
            @if (selected_dispo_type !== "FFL") {
            <div class="form_input">
              <label class="control-label label" for="middle_name" style="display: inline-block">
                Middle Name:
              </label>
              <input type="text" class="form-control text-uppercase input" formControlName="middle_name"
                style="display: inline-block" />
            </div>
            }
            <!-- Last Name-->
            @if (selected_dispo_type !== "FFL") {
            <div class="form_input disposition-last-name-row">
              <label class="control-label label" for="last_name" style="display: inline-block">
                <span class="required">*</span> Last Name:
              </label>
              <input type="text" class="form-control text-uppercase input1" formControlName="last_name"
                style="display: inline-block" />
              <label class="control-label label" for="sr_name" style="display: inline-block">
                Sir Name:
              </label>
              <ng-select [items]="sr_names" [multiple]="false" [closeOnSelect]="true" appendTo="body"
                class="form-control text-uppercase input2" formControlName="sr_name"
                style="display: inline-block"></ng-select>
            </div>
            }
            <!-- Address 1 -->
            <div class="form_input">
              <label class="control-label label" for="address" style="display: inline-block">
                Address:
              </label>
              <input type="text" class="form-control text-uppercase input" formControlName="address"
                style="display: inline-block" />
            </div>
            <!-- Address 2 -->
            <div class="form_input">
              <label class="control-label label" for="address_2" style="display: inline-block">
                Address2:
              </label>
              <input type="text" class="form-control text-uppercase input" formControlName="address_2"
                style="display: inline-block" />
            </div>
            <!-- Zip Code -->
            <div class="form_input">
              <label class="control-label label" for="zip_code" style="display: inline-block">
                Zip Code:
              </label>
              <input appOnlyNumbers type="text" class="form-control text-uppercase input" formControlName="zip_code"
                style="display: inline-block" (input)="fetchCityState()" />
            </div>
            <!-- City -->
            <div class="form_input">
              <label class="control-label label" for="city" style="display: inline-block">
                City:
              </label>
              <ng-select [items]="distinct_cities" [addTag]="true" [multiple]="false" [closeOnSelect]="true"
                appendTo="body" class="form-control text-uppercase input" formControlName="city"
                style="display: inline-block"></ng-select>
            </div>
            <!-- State -->
            <div class="form_input">
              <label class="control-label label" for="state" style="display: inline-block">
                State:
              </label>
              <ng-select [items]="states" bindLabel="dropdown_label" bindValue="state_name" [multiple]="false"
                [closeOnSelect]="true" appendTo="body" class="form-control text-uppercase input" formControlName="state"
                style="display: inline-block"></ng-select>
            </div>
            <!-- Dispo Date -->
            <div class="form_input">
              <label class="control-label label" for="dispo_date" style="display: inline-block">
                <span class="required">*</span> Disposition Date:
              </label>
              <!-- <input
                                        type="text"
                                        class="form-control text-uppercase input"
                                        formControlName="dispo_date"
                                        style="display: inline-block"
                                        /> -->
              <input #date_acquired type="text" class="form-control text-uppercase input" formControlName="dispo_date"
                id="dispo_date" placeholder="__/__/__ __:__" [bsConfig]="bsConfig" [readOnly]="false" bsDatepicker
                autocomplete="off" />
              <i class="fa-solid fa-calendar caledar_icon_inside_input"></i>
            </div>
            <div class="disposition-actions">
              <div class="disposition-action-row">
                <button type="button" class="btn btn-secondary progression_btn btn-sm" (click)="previousStepClick()">
                  Previous Step
                </button>
                <button type="button" class="btn btn-secondary progression_btn btn-sm" (click)="nextStepClick()"
                  [disabled]="disableNextBtn">
                  Next
                </button>
              </div>
            </div>
          </div>
          }
          <!-- left side step 3 -->
          @if (stepper.selectedIndex === 2) {
          <div class="col-6 left_side" style="min-height: 475px" [ngClass]="{
                'margin-top': stepper.selectedIndex === 2,
              }">
            <div class="card_right_side">
              <span style="
                    display: block;
                    text-align: center;
                    font-weight: bold;
                    margin-bottom: 10px;
                    padding-top: 20px;
                    color: white;
                    font-size: 20px;
                  ">Disposition To
              </span>
              <br />
              <br />
              <div class="row">
                <div class="col-12">
                  @if (selected_dispo_type === "FFL") {
                  <div>
                    <!-- FFL -->
                    <div class="flex-container">
                      <span class="dispo_info_title_step3">FFL: </span>
                      <span class="dispo_info_value_step3">{{
                        disposition_form.get("ffl").value
                        }}</span>
                    </div>
                    <!-- Disposed To -->
                    <div class="flex-container">
                      <span class="dispo_info_title_step3">Disposed To:
                      </span>
                      <span class="dispo_info_value_step3">{{
                        disposition_form.get("disposed_to").value
                        }}</span>
                    </div>
                    <!-- Business Name -->
                    <div class="flex-container">
                      @if (disposition_form.get('business_name')?.value) {
                      <span class="dispo_info_title_step3">
                        Business Name:
                      </span>
                      }
                      <span class="dispo_info_value_step3">{{
                        disposition_form.get("business_name").value
                        }}</span>
                    </div>
                  </div>
                  }
                  @if (selected_dispo_type !== "FFL") {
                  <div>
                    <!-- 4473 ID -->
                    <div class="flex-container">
                      <span class="dispo_info_title_step3">4473 ID: </span>
                      <span class="dispo_info_value_step3">
                        {{ disposition_form.get("form_4473_no").value }}
                      </span>
                    </div>
                    <!-- Name -->
                    <div class="flex-container">
                      <span class="dispo_info_title_step3">Name: </span>
                      <span class="dispo_info_value_step3">
                        {{ disposition_form.get("first_name").value }}
                        {{ disposition_form.get("middle_name").value }}
                        {{ disposition_form.get("last_name").value }}
                        {{ disposition_form.get("sr_name").value }}
                      </span>
                    </div>
                    <!-- Address -->
                    <div class="flex-container">
                      <span class="dispo_info_title_step3">Address: </span>
                      <span class="dispo_info_value_step3">
                        {{ disposition_form.get("address").value }},
                        {{ disposition_form.get("address_2").value }}
                      </span>
                    </div>
                    <!-- City State Zipcode -->
                    <div class="flex-container">
                      <span class="dispo_info_title_step3" style="color: transparent">Address:
                      </span>
                      <span class="dispo_info_value_step3">
                        {{ disposition_form.get("city").value }},
                        {{ disposition_form.get("state").value }},
                        {{ disposition_form.get("zip_code").value }}
                      </span>
                    </div>
                  </div>
                  }
                  <br />
                  <br />
                  <br />
                  <!-- Notes -->
                  <div class="flex-container">
                    <label class="control-label dispo_info_title_step3" for="notes" style="display: inline-block">
                      Notes:
                    </label>
                    <textarea type="text" class="form-control text-uppercase notes" formControlName="notes" style="
                          display: inline-block;
                          word-wrap: break-word;
                          resize: none;
                        " placeholder=" Optional Notes"></textarea>
                  </div>
                  <br />
                  <!-- Disposition Date -->
                  <div class="flex-container">
                    <label class="control-label dispo_info_title_step3" for="dispo_date" style="display: inline-block">
                      Disposition Date:
                    </label>
                    <div style="position: relative; display: inline-flex; align-items: center;">
                      <input #date_acquired type="text" class="form-control text-uppercase" style="width: 200px; padding-right: 30px;"
                        formControlName="dispo_date" id="dispo_date" placeholder="__/__/__ __:__" [bsConfig]="bsConfig"
                        [readOnly]="false" bsDatepicker autocomplete="off" />
                      <i class="fa-solid fa-calendar icon_inside_input_step_3"></i>
                    </div>
                  </div>
                  <br />
                  <br />
                </div>
              </div>
            </div>
            <div class="disposition-actions disposition-review-actions">
              <div class="disposition-action-row">
                <button type="button" class="btn btn-secondary progression_btn btn-sm" (click)="previousStepClick()">
                  Previous Step
                </button>
                <button type="button" class="btn btn-primary btn-sm progression_btn disposition-submit-btn"
                  (click)="submitDispositionClick()">
                  Submit Disposition
                </button>
              </div>
            </div>
          </div>
          }
          <!-- right side step 2 -->
          <div class="col-6 right_side ms-auto">
            <div class="card_right_side" [ngClass]="{
                'margin-top':
                  stepper.selectedIndex === 0 || stepper.selectedIndex === 2,
              }">
              <span style="
                  display: block;
                  text-align: center;
                  font-weight: bold;
                  margin-bottom: 10px;
                  padding-top: 20px;
                  color: white;
                  font-size: 20px;
                ">Selected Firearms For Disposition
              </span>
              @for (firearm of filteredFirearms; track firearm) {
              <div class="selected-firearm-summary">
                <div class="selected-firearm-name">
                  <span class="selected-firearm-label">Firearm:</span>
                  <span class="selected-firearm-value">{{ firearm.firearm }}</span>
                </div>
                <div class="selected-firearm-serial">
                  <span class="selected-firearm-label">Serial #:</span>
                  <span class="selected-firearm-value">{{ firearm.serial_number }}</span>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>